import { DeviceOrientation as DOrientation } from "../../../models/deviceOrientationModel";
import { useEffect, useState } from "react";
import { Dimensions } from "react-native";

const computeDeviceOrientation = (): DOrientation => {
  const width = Dimensions.get("window").width;
  return {
    isLargeDevice: width >= 1450,
    isMediumDevice: width < 1450 && width >= 1145,
    isSmallDevice: width < 1145 && width > 200,
    isMobileDevice: width < 600 && width > 200,
  };
};

export const DeviceOrientation = () => {
  const [deviceOrientation, setDeviceOrientation] = useState<DOrientation>(
    computeDeviceOrientation
  );

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", () => {
      try {
        setDeviceOrientation(computeDeviceOrientation());
      } catch (e) {
        console.error(`Dimensions event error: ${e}`);
      }
    });

    return () => subscription.remove();
  }, []);

  return deviceOrientation;
};
